<template>
  <div>
    <EmergencyOverview
        v-if="facility.displayId"
        :elevator-id="facility.displayId"
      />
  </div>
</template>
<script>

import EmergencyOverview from '@/modules/display/views/emergency/EmergencyOverview';

export default {
  name: 'FacilityDisplayEmergencyTab',
  components: {EmergencyOverview},
  props: {
    facility: {}
  }
}
</script>